
// prop-types is library for typechecking of props
import PropTypes from "prop-types";
import * as React from 'react';
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Popover, Typography } from "@mui/material";
import PlanetInfopPop from "./PlanetInfopPop";
import { useTranslation } from 'react-i18next';
import "./ChartItemPlanet.css"

function ChartItemPlanet({ planetData, key }) {

  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const plantInfo = [
    { name: t("Place"), value: planetData.place },
    { name: t("Rashiya"), value: planetData.rashiya },
    { name: t("Nekatha"), value: planetData.nekatha },
    { name: t("Ucha"), value: planetData.ucha },
  ];

  return (
    <div key={key}>
      <strong className="hoverText"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {planetData.planet} {planetData.wakra ? " (R)" : ""}
      </strong>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >

        <PlanetInfopPop data={plantInfo} title={planetData.planet} />
      </Popover>
    </div>
  );
}

// Setting default values for the props of MiniInfoCard
ChartItemPlanet.defaultProps = {
  color: "info",
};

// Typechecking props for the MiniInfoCard
ChartItemPlanet.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  planetData: PropTypes.object,
  key: PropTypes.string
};

export default ChartItemPlanet;
